import React, { FC } from 'react';

import { RoverLogo as RoverLogoIcon } from '@rover/icons';
import { Color } from '@rover/kibble/styles';

const RoverLogo: FC = () => (
  <RoverLogoIcon
    fill={Color.BRAND_ROVER.toString()}
    height={35}
    width={105}
    paddingTop={['0x', '2x']}
  />
);

export default RoverLogo;
